import React, { useEffect } from 'react'
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import {
  PageHeader,
  Btn,
  TextBtn,
  CustomDropdown,
  CustomCheckbox,
  ConfirmDialog,
  CustomTabView,
} from '../../../../components'
import {
  hideLoadingBox,
  showLoadingBox,
  showMessageBox,
} from '../../../../store/actions/system.actions'
import { tableCellCentered } from '../../../../assets/js/styles'
import { TabPanel } from 'primereact/tabview'
import { Fieldset } from 'primereact/fieldset'
import useConfiguracoesDeUsuario from './ConfiguracoesDeUsuarioHook'

function ConfiguracoesDeUsuarios({ dispatch, history }) {
  const { state, localDispatch } = useConfiguracoesDeUsuario()

  // Observables
  useEffect(() => {
    if (state.errorMessage) {
      dispatch(showMessageBox(null, state.errorMessage))
      localDispatch.resetState()
    }
  }, [state.errorMessage])

  useEffect(() => {
    if (state.successMessage) {
      dispatch(showMessageBox(state.successMessage))
      localDispatch.resetState()
    }
  }, [state.successMessage])

  useEffect(() => {
    if (state.loadingMessage) dispatch(showLoadingBox('Carregando', 'Aguarde . . .'))
    else dispatch(hideLoadingBox())
  }, [state.loadingMessage])

  useEffect(() => {
    if (state.selectedTp) localDispatch.getUsuariosFromTp(state.selectedTp.id)
  }, [state.selectedTp])

  useEffect(() => {
    localDispatch.getAllTps()
  }, [])

  return (
    <div>
      <PageHeader>
        <span>S.19 - Configurações de Usuarios</span>
      </PageHeader>
      <div style={{ marginTop: 20 }}>
        <CustomTabView
          activeIndex={state.activeIndex}
          onTabChange={index => localDispatch.onTabChange(index, state.tps, state.allUsers)}
        >
          <TabPanel header="Inativação de Usuarios">
            <div className="p-grid p-align-center">
              <div className="p-md-3 p-col-12">
                <CustomDropdown
                  label={'Operadores Logísticos'}
                  onChange={localDispatch.onTpSelectedChange}
                  options={state.tps}
                  optionLabel={'name'}
                  value={state.selectedTp}
                  filter={true}
                />
              </div>
              <div
                className="p-md-1 p-col-4"
                style={{ display: 'inline-block', marginTop: 30, marginLeft: 20 }}
              >
                <Btn
                  onClick={() =>
                    localDispatch.onClickDesativar(state.selectedTp, state.usersSelected)
                  }
                >
                  Desativar
                </Btn>
              </div>
              <div className="p-md-1 p-col-4" style={{ display: 'inline-block', marginTop: 30 }}>
                <Btn
                  onClick={() => localDispatch.onClickAtivar(state.selectedTp, state.usersSelected)}
                >
                  Ativar
                </Btn>
              </div>
              <div className="p-md-1 p-col-4" style={{ display: 'inline-block', marginTop: 30 }}>
                <Btn
                  onClick={() => localDispatch.onClickExportar(state.selectedTp, state.usersSelected)}
                >
                  Exportar
                </Btn>
              </div>
              <div className="p-col" style={{ display: 'inline-block', marginTop: 30 }}>
                <TextBtn onClick={() => history.goBack()}>Voltar</TextBtn>
              </div>
            </div>
            <div className="p-grid p-col-12" style={{ marginTop: 10 }}>
              <DataTable
                value={state.users}
                emptyMessage="Nenhum usuario a ser exibido"
                selection={state.usersSelected}
                onSelectionChange={e => localDispatch.setSelections(e.value)}
                responsive
              >
                <Column
                  className="table-column-fix"
                  selectionMode="multiple"
                  style={{ width: '3em' }}
                  bodyStyle={{ textAlign: 'center' }}
                />
                <Column
                  field="id"
                  header="Código"
                  className="table-column-fix"
                  style={tableCellCentered()}
                />
                <Column
                  field="name"
                  header="Nome"
                  className="table-column-fix"
                  style={tableCellCentered()}
                />
                <Column
                  field="email"
                  header="Email"
                  className="table-column-fix"
                  style={tableCellCentered()}
                />
                <Column
                  field="actived"
                  header="Ativo"
                  className="table-column-fix"
                  style={tableCellCentered()}
                  body={user => <CustomCheckbox checked={user.actived} disabled />}
                />
              </DataTable>
            </div>
          </TabPanel>
          <TabPanel header="Clonagem de Usuario">
            <div className="p-grid p-align-center">
              <div className="p-md-3 p-col-12">
                <CustomDropdown
                  label={'Usuário Base'}
                  onChange={localDispatch.onSelectedBaseUserChange}
                  options={state.allUsers}
                  value={state.selectedBaseUser}
                  filter={true}
                />
              </div>
              <div className="p-md-3 p-col-12">
                <CustomDropdown
                  label={'Usuário Alvo'}
                  onChange={localDispatch.onSelectedTargetUserChange}
                  options={state.allUsers}
                  value={state.selectedTargetUser}
                  filter={true}
                />
              </div>
              <div className="p-md-1 p-col-8" style={{ display: 'inline-block', marginTop: 30 }}>
                <Btn
                  onClick={() =>
                    localDispatch.onClickClonar(
                      state.flagUserGroup,
                      state.flagCompanies,
                      state.flagTps,
                      state.flagOpCenter,
                      state.flagPatrimonio,
                      state.flagGroupCompanies,
                      state.selectedBaseUser,
                      state.selectedTargetUser,
                    )
                  }
                >
                  Clonar
                </Btn>
              </div>
              <div className="p-col" style={{ display: 'inline-block', marginTop: 30 }}>
                <TextBtn onClick={() => history.goBack()}>Voltar</TextBtn>
              </div>
              <Fieldset legend="Opções" className="p-col-12">
                <div className="p-grid ">
                  <div className="p-sm-6 p-md-3">
                    <CustomCheckbox
                      checked={state.flagUserGroup}
                      onChange={value => localDispatch.onCheckBoxChange('flagUserGroup', value)}
                    >
                      {' '}
                      Grupos de Usuarios{' '}
                    </CustomCheckbox>
                  </div>
                  <div className="p-sm-6 p-md-3">
                    <CustomCheckbox
                      checked={state.flagCompanies}
                      onChange={value => localDispatch.onCheckBoxChange('flagCompanies', value)}
                    >
                      {' '}
                      Empresas{' '}
                    </CustomCheckbox>
                  </div>
                  <div className="p-sm-6 p-md-3">
                    <CustomCheckbox
                      checked={state.flagTps}
                      onChange={value => localDispatch.onCheckBoxChange('flagTps', value)}
                    >
                      {' '}
                      Operadores Logísticos{' '}
                    </CustomCheckbox>
                  </div>
                  <div className="p-sm-6 p-md-3">
                    <CustomCheckbox
                      checked={state.flagOpCenter}
                      onChange={value => localDispatch.onCheckBoxChange('flagOpCenter', value)}
                    >
                      {' '}
                      Central de Operações{' '}
                    </CustomCheckbox>
                  </div>
                  <div className="p-sm-6 p-md-3">
                    <CustomCheckbox
                      checked={state.flagPatrimonio}
                      onChange={value => localDispatch.onCheckBoxChange('flagPatrimonio', value)}
                    >
                      {' '}
                      Patrimonio Owner{' '}
                    </CustomCheckbox>
                  </div>
                  <div className="p-sm-6 p-md-3">
                    <CustomCheckbox
                      checked={state.flagGroupCompanies}
                      onChange={value =>
                        localDispatch.onCheckBoxChange('flagGroupCompanies', value)
                      }
                    >
                      {' '}
                      Grupo de Empresas{' '}
                    </CustomCheckbox>
                  </div>
                </div>
              </Fieldset>
            </div>
          </TabPanel>
        </CustomTabView>
      </div>
      <ConfirmDialog
        content={'Deseja continuar com a operação?'}
        isVisible={state.confirmIsVisible}
        onCancelar={localDispatch.onConfirmCancel}
        onOk={state.confirmAction}
        title={'Atenção'}
      />
    </div>
  )
}
const mapStateToProps = ({ system: { selectedTp } }) => ({ selectedTp })
export default connect(mapStateToProps)(withRouter(ConfiguracoesDeUsuarios))
